import { observer } from 'mobx-react';
import useStores from 'hooks/useStores';
import Header from 'components/@common/Header';

import { DEFAULT_PAGE } from 'constants';
import Container from './styles';

function Layout({ children }) {
  const { AppHandler } = useStores();

  const onClickPreviousButton = () => AppHandler.setAppLocation(DEFAULT_PAGE);

  return (
    <Container>
      <Header
        onClickPreviousButton={AppHandler.page !== DEFAULT_PAGE ? onClickPreviousButton : null}
      />
      <div className="layout-content">{children}</div>
    </Container>
  );
}

export default observer(Layout);
